<template>
  <div class="module videos">
    <div class="container">
      <h3 class="module-title" style="text-align:center">学习文档/视频</h3>
      <el-row :gutter="25" style="margin:50px 0 0 0;">
        <el-col :span="8" v-for="(item, index) in innwerData" :key="index">
          <el-dialog
            :title="item.video.name"
            :visible.sync="item.dialogTableVisible"
            :destroy-on-close="true"
          >
            <video width="100%" ref="video" controls>
              <source :src="item.video.src" type="video/mp4" />
              您的浏览器不支持 video 标签。
            </video>
          </el-dialog>
          <div class="innerbox3">
            <div class="innerbox3-pic" @click="showVideo(index)">
              <img :src="item.pic" alt />
            </div>
            <div class="innerbox3-text">
              <i class="iconfont" :class="item.icon"></i>
              <h4 class="innerbox3-title">{{ item.title }}</h4>
              <h5
                class="innerbox3-subtitle"
                v-for="(subitem, subindex) in item.subtitle"
                :key="subindex"
              >
                <a :href="subitem.href" target="_blank">{{ subitem.name }}</a>
              </h5>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "product",
  props: {
    msg: String,
  },
  data() {
    return {
      activeName: "tab1",
      innwerData: [
        {
          title: "CS相关文档资料/视频",
          pic: require("../assets/images/getech/CS.png"),
          subtitle: [
            // {
            //   name: "ERP操作手册",
            //   href: "https://www.kancloud.cn/fesion/erp_cs/1803508",
            // },
            // {
            //   name: "CS软件包下载",
            //   href: "http://feixunoa.xicp.net:10081/yhdbi/login.aspx"
            // }
          ],
          icon: "icon-diannao",
          video: {
            name: "CS视频教程",
            src:
              "http://fx-app-tool.oss-cn-shenzhen.aliyuncs.com/video/CS%E5%85%A5%E9%97%A8%E5%9F%B9%E8%AE%AD.mp4",
          },
          dialogTableVisible: false,
        },
        {
          title: "BS相关文档资料/视频",
          pic: require("../assets/images/getech/BS.png"),
          subtitle: [
            // {
            //   name: "BS操作文档",
            //   href: "https://www.kancloud.cn/fesion/bsdocument/1800105",
            // },
            {
              name: "BS软件包下载",
              href: "http://appdoc.feixuns.com/BS/Index.html",
            },
            {
              name: "BS考核题目下载",
              href: "http://demo.feixuns.com/assets/bstest.pdf",
            },
          ],
          icon: "icon-wangyesheji",
          video: {
            name: "BS视频教程",
            src:
              "http://fx-app-tool.oss-cn-shenzhen.aliyuncs.com/video/BS%E5%85%A5%E9%97%A8%E5%9F%B9%E8%AE%AD.mp4",
          },

          dialogTableVisible: false,
        },
        {
          title: "APP相关文档资料/视频",
          pic: require("../assets/images/getech/APP.png"),
          subtitle: [
            // {
            //   name: "APP操作文档",
            //   href:
            //     "https://feixuns.yuque.com/books/share/6eab9e87-90a0-48ff-92ee-c522403782a3?",
            // },
            {
              name: "APP演示",
              href: "http://demo.feixuns.com/appDemo/pcmain.html",
            },

            // {
            //   name: "APP下载",
            //   href:
            //     "https://feixuns.yuque.com/docs/share/d8f73d25-1bc9-4af7-baab-2b776868e94a?#%20%E3%80%8AAPP%E5%AE%89%E8%A3%85%E5%8C%85%E4%B8%8B%E8%BD%BD%E6%8C%87%E5%BC%95%E3%80%8B",
            // },
          ],
          icon: "icon-shouji-tianchong",
          video: {
            name: "APP视频教程",
            src:
              "http://fx-app-tool.oss-cn-shenzhen.aliyuncs.com/video/APP%E5%85%A5%E9%97%A8%E5%9F%B9%E8%AE%AD.mp4",
          },

          dialogTableVisible: false,
        },
      ],
    };
  },
  methods: {
    showVideo(index) {
      this.innwerData[index].dialogTableVisible = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.module-title {
  text-align: center;
}
.custTab >>> .el-tabs__nav-wrap::after {
  opacity: 0;
}
.custTab >>> .el-tabs__nav-wrap {
  width: 500px;
  margin: 0 auto;
}
.custTab >>> .el-tabs__item {
  font-size: 18px;
}
</style>
